import React from 'react';
import CostCalcTable from '../../chancemng/costcalc/CostCalcTable';
import { sumCostCalcs } from '../../chancemng/costcalc/costCalcShared';

// 확정된(읽기전용) 원가 산출 내역 표(프로젝트 쪽). 기존 관례대로 chancemng의
// CostCalcTable/costCalcShared를 그대로 재사용한다(옵션 B, 편집 표와 확정 표가 표를
// 공유한다는 설계를 chancemng/projectmng 양쪽에 동일하게 적용).
const CostCalcLockList = ({ costs }) => {
  if (!costs || costs.length === 0) {
    return null;
  }

  const rows = costs.map((cost, index) => ({
    key: cost.id ?? index,
    no: index + 1,
    isEtc: cost?.masterTyp !== 'N',
    productNm: cost.productNm,
    productDesc: cost.productDesc,
    qty: cost.expCnt,
    unit: cost.productUnit,
    sellPrice: cost.unitVal,
    sellAmount: cost.saleVal,
    buyPrice: cost.priceVal,
    buyAmount: cost.buyVal,
    partnerNm: cost.sellPartnerNm,
    profit: cost.saleProfit,
    profitRate: cost.salePct,
    missingPartner: !cost.sellPartnerNm,
    invalid: false,
  }));

  const totals = sumCostCalcs(costs);

  return <CostCalcTable rows={rows} totals={totals} editable={false} />;
};

export default CostCalcLockList;
